import React, { useState ,useRef  } from "react";
import { Grid, TextField, Button, Paper, IconButton } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { SelectWithLabel } from "../../utils/selectWithLabel";
import { ExitButton } from "../../utils/etc";
import { editFlight, loadFlights } from "../../store/flights";
import { changeFlightNumber, changeDepartureDate } from "../../store/dcs";
import { Link } from "react-router-dom";
import styles from "./styles";
import moment from "moment";
import checkPermissions from "../../utils/checkPermissions";
import dayjs from "dayjs";
import { TimePicker } from "antd";
const pad = (num) => {
  return Number(num) < 10 ? '0' + num : num
}

const isFlightOpen = (flight) => {
  if (flight && !!flight.DCSFltStatus) {
    // FIXME // getting occasional error for betterRow.status
    // NOTE // 10 is closed, 5 or '' is open
    let dcsStatus = flight.DCSFltStatus;
    if (dcsStatus === "10") {
      return false;
    } else {
      return true;
    }
  }
  return true;
};

const formatOutput = (flight) => {
  try {
    let output = {
      fltno: flight.FlightNumber,
      startDate:
        pad(flight.Departure.getFullYear()) +
        "-" +
        pad(flight.Departure.getMonth() + 1) +
        "-" +
        pad(flight.Departure.getDate()),
      stopDate:
        pad(flight.Departure.getFullYear()) +
        "-" +
        pad(flight.Departure.getMonth() + 1) +
        "-" +
        pad(flight.Departure.getDate()),
      originText: flight.Origin || "",
      destText: flight.Destination || "",
      departureTime: flight.airportDepTime || "",
      arrivalTime: flight.airportArrTime || "",
      flightId: flight.fltid,
      comment: flight.comment || "",
      newStatus: "Delayed",
      rfd: flight.RFD || "",
      duration: flight.duration,
    };

    return output;
  } catch (e) {
    console.error(e);
  }
};

const formatFlightDate = (date) => {
  // NOTE // input: 2021-08-17, output: 17AUG2021
  let day = date.slice(8, 10);
  let month = date.slice(5, 7);
  let year = date.slice(0, 4);
  let monthsArr = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  month = monthsArr[Number(month) - 1];
  return `${day + month + year}`;
};

// TODO // 10/1/21 DCS link, close/update flight dispatch,
function FlightModal(props) {
  const dispatch = useDispatch();
  const classes = props.classes;
  let flight = props.item;
  let modal = props.modal;
  const [page, setPage] = React.useState("Menu");
  const [updateOutput, setUpdateOutput] = React.useState(formatOutput(flight));
  const [error, setError] = useState("");
  const airline = useSelector((state) => state.entities.flights.airline);
  const flightDate = useSelector((state) => state.entities.flights.flightDate);
  // const [arrivalTime, setArrivalTime] = useState('');

  // const startDate = useSelector((state) => state.entities.flights.flightDate);
  // const endDate =useSelector((state) => state.entities.flights.flightDate);
  const editStatus = useSelector(
    (state) => state.entities.flights.editReqStatus
  );
  const userType = useSelector((state) => state.entities.auth.userType);

  // const [arrivalTime, setArrivalTime] = useState(updateOutput.arrivalTime || "");

  // NOTE // used for the link to the dcs-page
  const setDcsFilters = () => {
    dispatch(changeFlightNumber(flight.FlightNumber));
    // NOTE // format = YYYY-MM-DD
    dispatch(changeDepartureDate(flightDate));
  };
  const [isArrivalPickerSelected, setArrivalPickerSelected] = useState("");
  const [isDeparturePickerSelected, setDeparturePickerSelected] = useState("");
  const [arrival, setArrivalTime] = useState(updateOutput.arrivalTime);
  const [departure, setDepartureTime] = useState(updateOutput.departureTime);
  const [startDate, setStartDate] = useState(formatOutput(flight).startDate);
  const [endDate, setEndDate] = useState(formatOutput(flight).stopDate);
  const [showMessage, setDayMessage] = useState(false);
  const [message, setMessage] = useState("");
  const departureTimePickerRef = useRef(null);
  const arrivalTimePickerRef = useRef(null);
 
  const handlePickerChange = (newValue, pickerType) => {
    const formattedTime = dayjs(newValue).format("HH:mm");
    if (pickerType === "departureTime") {
      setDepartureTime(formattedTime)
      setOutput(formattedTime, pickerType);
      console.log(formattedTime);
      setDeparturePickerSelected("#3f51b5");
    } else if (pickerType === "arrivalTime") {
      setArrivalTime(formattedTime);
      setOutput(formattedTime, pickerType);
      setArrivalPickerSelected("#3f51b5");
    }
  };

  const handlePickerBlur = (pickerType) => {
    if (pickerType === "departureTime") {
      setDeparturePickerSelected(false);
     
    } else if (pickerType === "arrivalTime") {
      setArrivalPickerSelected(false);
    }
  };
  const departureLabel = "Estimated Time of Dep. (time is local)";
  const arrivalLabel = "Estimated Time of Arrival (time is local)";
  const errorMsgDeparture="You are not permitted to update the time since the arrival time moves to the next day." 
  const errorMsgArrival="You are not permitted to update the time since the departure time moves to the previous day."
  const updateMessageAndTime = (outputCopy, flight, errorMsg) => {
    setDayMessage(true);
    setMessage(errorMsg);
    outputCopy["startDate"] = formatOutput(flight).startDate;
    setStartDate(formatOutput(flight).startDate);
    setDepartureTime(formatOutput(flight).departureTime);
    setArrivalTime(formatOutput(flight).arrivalTime);
  };
  
const setOutput = (data, prop) => {
  let outputCopy = _.cloneDeep(updateOutput);
  outputCopy[prop] = data;

  if (prop === "departureTime") {
    let [hours, mins] = data.split(":");
    let endDate = new Date(updateOutput.startDate + " " + hours + ":" + mins);
    endDate.setHours(endDate.getHours() + updateOutput.duration._data.hours);
    endDate.setMinutes(
      endDate.getMinutes() + updateOutput.duration._data.minutes
    );
    let arrivalTime =
      pad(endDate.getHours()) + ":" + pad(endDate.getMinutes());
    outputCopy["arrivalTime"] = arrivalTime;

    outputCopy["stopDate"] = moment(endDate).format("YYYY-MM-DD");
    setEndDate(formatOutput(flight).stopDate);
    setStartDate(formatOutput(flight).startDate);

    if (outputCopy["stopDate"] !== formatOutput(flight).stopDate) {
      updateMessageAndTime(outputCopy, flight, errorMsgDeparture);
      outputCopy["stopDate"] = formatOutput(flight).stopDate;
      departureTimePickerRef.current.blur();
    } else {
      setDayMessage(false);
      setMessage("");
      // If not, update the arrival time based on the new departure time
      let arrivalTime =
        pad(endDate.getHours()) + ":" + pad(endDate.getMinutes());
      outputCopy["arrivalTime"] = arrivalTime;
      setArrivalTime(arrivalTime);
      setEndDate(outputCopy["stopDate"]);
    }
  } else if (prop === "arrivalTime") {
    let [hours, mins] = data.split(":");
    let endDate = new Date(updateOutput.stopDate + " " + hours + ":" + mins);
    endDate.setHours(endDate.getHours() - updateOutput.duration._data.hours);
    endDate.setMinutes(
      endDate.getMinutes() - updateOutput.duration._data.minutes
    );
    let departureTime =
      pad(endDate.getHours()) + ":" + pad(endDate.getMinutes());
    outputCopy["departureTime"] = departureTime;
    outputCopy["startDate"] = moment(endDate).format("YYYY-MM-DD");

    if (outputCopy["startDate"] !== formatOutput(flight).startDate) {
      updateMessageAndTime(outputCopy, flight, errorMsgArrival);
      outputCopy["startDate"] = formatOutput(flight).startDate;
      arrivalTimePickerRef.current.blur();
    } else {
      setDayMessage(false);
      setMessage("");
      let departureTime =
      pad(endDate.getHours()) + ":" + pad(endDate.getMinutes());
      outputCopy["departureTime"] = departureTime;
      setDepartureTime(departureTime);
      setStartDate(outputCopy["startDate"]);
    }
  }

  setUpdateOutput(outputCopy);
};

  
  

  const pad = (n) => {
    return n < 10 ? "0" + n : n;
  };

  const updateFlight = () => {
    let outputCopy = _.cloneDeep(updateOutput);
    // TODO // restricting times is causing issue. Fix or remove commented out sections in this function
    // let outputDepTime = outputCopy.departureTime
    // let outputArrTime = outputCopy.arrivalTime
    // NOTE // measuring time in hours (i.e. 11.5 === 11:30, 11.5 is output)
    // let outputDepHours = getHoursDecimal(outputDepTime)
    // let outputArrHours = getHoursDecimal(outputArrTime)
    // let currentDepHours = getHoursDecimal(flight.Departure)
    // let currentArrHours = getHoursDecimal(flight.Arrival)

    // NOTE // getting the hours to make sure new times are after the current
    // if (outputDepHours < currentDepHours || outputArrHours < currentArrHours) {
    //   setError('The new departure and arrival time must be after the old times')
    // }
    // else {
    setError("");
    outputCopy.startDate = formatFlightDate(outputCopy.startDate);
    outputCopy.stopDate = formatFlightDate(outputCopy.stopDate);
    let payload = {
      editData: outputCopy,
      flightNumber: flight.FlightNumber,
      type: "updateFlightTime",
    };
    dispatch(editFlight(payload));
    // }
  };

  /* NOTE // Button Colors  Red: '#eb494e', Green: '#03fc66', Grey: '#dedede' */
  if (page === "Menu") {
    return (
      <Paper className={classes.menu}>
        <Grid
          container
          justifyContent="center"
          item
          xs={12}
          style={{ backgroundColor: "rgb(63, 81, 181)" }}
        >
          <Grid item xs={4}></Grid>
          <Grid container justifyContent="center" item xs={4}>
            <h4>Flight Menu</h4>
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid container justifyContent="center" item xs={1}>
            {/* modal.setToggle */}
            <ExitButton exit={modal.setToggle} />
          </Grid>
        </Grid>
        <Grid container style={{ marginTop: "15px", marginBottom: "15px" }}>
          <Grid item xs={4} container justifyContent="flex-end">
            {/* Set DCS filters, go to dcs page */}
            <Link
              to={"DCS"}
              style={{ textTransform: "none", textDecoration: "none" }}
            >
              <Button
                style={{
                  backgroundColor: "#dedede",
                  height: "40px",
                  marginRight: "6px",
                }}
                variant="contained"
                size="small"
                onClick={() => {
                  setDcsFilters();
                }}
              >
                Go To Dcs
              </Button>
            </Link>
          </Grid>
          <Grid item xs={4} container justifyContent="center">
            <Button
              style={{
                backgroundColor: "#dedede",
                height: "40px",
                marginRight: "6px",
              }}
              variant="contained"
              size="small"
              disabled={!checkPermissions(userType, airline, "editTime")}
              onClick={() => {
                setPage("Update");
              }}
            >
              Update Flight
            </Button>
          </Grid>
          <Grid item xs={4} container justifyContent="flex-start">
            <Button
              style={{ backgroundColor: "#dedede", height: "40px" }}
              variant="contained"
              size="small"
              disabled={!checkPermissions(userType, airline, "closeFlight")}
              onClick={() => {
                setPage("Close");
              }}
            >
              {isFlightOpen(flight) ? "Close" : "Open"} Flight
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  } else if (page === "Update") {
    console.log(arrival);

    const statusChoices = [
      { label: "Delayed", value: "Delayed" },
      { label: "Cancelled", value: "Cancelled" },
    ];

    //OLD REASONS

    // const delayReasons = [
    //   {
    //     label: "Previous Flight Arriving Late Due To Longer In Flight Routing",
    //     value: "Previous Flight Arriving Late Due To Longer In Flight Routing",
    //   },
    //   { label: "Weather In Region", value: "Weather In Region" },
    //   { label: "Waiting For Fuel", value: "Waiting For Fuel" },
    //   { label: "Pilot Stuck In Traffic", value: "Pilot Stuck In Traffic" },
    //   {
    //     label:
    //       "Schedule Changes Due To A Mechanical Issue On A Different Plane In The Fleet",
    //     value:
    //       "Schedule Changes Due To A Mechanical Issue On A Different Plane In The Fleet",
    //   },
    //   {
    //     label: "Due To High Flight Volume (Air Traffic Control Delays)",
    //     value: "Due To High Flight Volume (Air Traffic Control Delays)",
    //   },
    //   { label: "Compounding Delays", value: "Compounding Delays" },
    //   {
    //     label: "Customs Delays On Previous Flight",
    //     value: "Customs Delays On Previous Flight",
    //   },
    //   {
    //     label: "Excessive Luggage On Previous Flight",
    //     value: "Excessive Luggage On Previous Flight",
    //   },
    //   { label: "Ground Operations", value: "Ground Operations" },
    //   {
    //     label: "Late Passengers On Previous Flight",
    //     value: "Late Passengers On Previous Flight",
    //   },
    //   {
    //     label: "Plane Released From Maintenance Later Than Scheduled",
    //     value: "Plane Released From Maintenance Later Than Scheduled",
    //   },
    //   {
    //     label: "Management Decision To Delay Flight",
    //     value: "Management Decision To Delay Flight",
    //   },
    //   {
    //     label: "Mechanical issue in fleet",
    //     value: "Mechanical issue in fleet",
    //   }
    // ];

    const delayReasons = [
        { label: "Wx", value: "Wx" },
        { label: "ATC", value: "ATC" },
        { label: "Customs Delay", value: "Customs Delay" },
        { label: "Mx in Fleet", value: "Mx in Fleet" },
        { label: "Ground Operations", value: "Ground Operations" },
        { label: "Crew", value: "Crew" },
        // {label:"Client", value: "Client"},
        {label:"TW Operation", value:"TW Operation"}
    ]

    return (
      <Paper className={classes.paper}>
        <Grid
          container
          justifyContent="center"
          item
          xs={12}
          style={{ backgroundColor: "rgb(63, 81, 181)", fontWeight: "bold" }}
        >
          <Grid item xs={4}></Grid>
          <Grid
            container
            justifyContent="center"
            alignContent="flex-end"
            item
            xs={4}
          >
            Update Flight
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid container justifyContent="center" item xs={1}>
            <IconButton
              variant="contained"
              size="small"
              style={{
                backgroundColor: "#eb494e",
                borderRadius: "0px",
                height: "21px",
                marginTop: "3px",
                border: "1px solid black",
              }}
              onClick={() => {
                modal.setToggle(false);
              }}
            >
              X
            </IconButton>
          </Grid>
          <Grid container justifyContent="center" item xs={12}>
            <div>{`${flight.FlightNumber} ${flight.Origin}-${flight.Destination}`}</div>
          </Grid>
        </Grid>
        <Grid
          container
          id="flight-modal-update"
          justifyContent="center"
          className={classes[props.editStatus]}
        >
          <Grid container justifyContent="center" item xs={6}>
            <TextField
              id="start-date"
              label="Start Date"
              type="date"
              defaultValue={props.flightDate}
              value={startDate}
              className={classes.flightModalTextField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setOutput(e.target.value, "startDate");
              }}
            />
          </Grid>
          <Grid container justifyContent="center" item xs={6}>
            <TextField
              id="end-date"
              label="End Date"
              type="date"
              defaultValue={props.flightDate}
              value={endDate}
              className={classes.flightModalTextField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setOutput(e.target.value, "stopDate");
              }}
            />
          </Grid>
          <Grid container justifyContent="center" item xs={6}>
        <label
          className="timepicker-label"
          style={{ color: isDeparturePickerSelected }}
        >
          {departureLabel}
        </label>
        <TimePicker
          ref={departureTimePickerRef}
          getPopupContainer={(trigger) => trigger.parentNode}
          format="HH:mm"
          minuteStep={1}
          showNow={false}
          value={dayjs(moment(departure, "HH:mm"))}
          defaultValue={dayjs(moment(updateOutput.departureTime, "HH:mm"))}
          onSelect={(newValue) => handlePickerChange(newValue, "departureTime")}
          onBlur={() => handlePickerBlur("departureTime")}
        />
      </Grid>
      <Grid container justifyContent="center" item xs={6}>
        <label
          className="timepicker-label"
          style={{ color: isArrivalPickerSelected }}
        >
          {arrivalLabel}
        </label>
        <TimePicker
          ref={arrivalTimePickerRef}
          format="HH:mm"
          getPopupContainer={(trigger) => trigger.parentNode}
          minuteStep={1}
          showNow={false}
          value={dayjs(moment(arrival, "HH:mm"))}
          defaultValue={dayjs(moment(updateOutput.arrivalTime, "HH:mm"))}
          onSelect={(newValue) => handlePickerChange(newValue, "arrivalTime")}
          onBlur={() => handlePickerBlur("arrivalTime")}
        />
      </Grid>
          <Grid container justifyContent="center" item xs={6}>
            <SelectWithLabel
              defaultVal={updateOutput.newStatus}
              handleChange={(e) => {
                setOutput(e.target.value, "newStatus");
              }}
              inputLabel={"New Status"}
              items={statusChoices}
              customStyle={{ width: "75%" }}
            />
          </Grid>
          <Grid container justifyContent="center" item xs={6}>
            <SelectWithLabel
              defaultVal={updateOutput.rfd}
              handleChange={(e) => {
                setOutput(e.target.value, "rfd");
              }}
              inputLabel={"Reason For Delay"}
              items={delayReasons}
              customStyle={{ width: "75%" }}
            />
          </Grid>
          <Grid container justifyContent="center" item xs={12}>
            <TextField
              id="comment"
              label="Comment"
              type="text"
              defaultValue={updateOutput.comment}
              style={{ width: "87%" }}
              className={classes.flightModalTextField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setOutput(e.target.value, "comment");
              }}
            />
          </Grid>
          <Grid
            container
            justifyContent="center"
            item
            xs={12}
            style={{ color: "red" }}
          >
            {error}
          </Grid>
          <p style={{ color: "red", width: "87%" }}>{showMessage && message}</p>
          <Grid
            container
            justifyContent="center"
            item
            xs={12}
            style={{ marginTop: "8px", marginBottom: "8px" }}
          >
            <Button
              variant="contained"
              style={{
                backgroundColor: "#03fc66",
                marginRight: "10px",
                fontWeight: "bold",
              }}
              onClick={() => {
                updateFlight();
              }}
            >
              Submit
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: "#eb494e", fontWeight: "bold" }}
              onClick={() => {
                setPage("Menu");
              }}
            >
              Back
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  } else if (page === "Close") {
    let flightStatus = isFlightOpen(flight);
    // NOTE // opens or closes a flight
    const changeFlightStatus = () => {
      let editData = {
        date: formatFlightDate(flightDate),
        origin: flight.Origin,
        activity: flightStatus ? "close" : "open",
      };
      let payload = {
        editData: editData,
        flightNumber: flight.FlightNumber,
        type: "closeFlight",
      };
      dispatch(editFlight(payload));
      setPage("Message Status");
    };

    return (
      <Paper className={classes.paper}>
        <Grid
          container
          justify="center"
          item
          xs={12}
          style={{ marginTop: "8px" }}
        >
          <h3>Are you sure you want to close the flight?</h3>
        </Grid>
        <Grid
          container
          justify="center"
          item
          xs={12}
          style={{ marginBottom: "8px", marginTop: "4px" }}
        >
          <Button
            variant="contained"
            style={{
              backgroundColor: "#03fc66",
              marginRight: "10px",
              fontWeight: "bold",
            }}
            onClick={() => {
              changeFlightStatus();
            }}
          >
            Yes
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: "#eb494e", fontWeight: "bold" }}
            onClick={() => {
              setPage("Menu");
            }}
          >
            No
          </Button>
        </Grid>
      </Paper>
    );
  } else if (page === "Message Status") {
    return (
      <Paper className={classes.paper}>
        <Grid container item xs={12} justify="center">
          <h3>{editStatus}</h3>
        </Grid>
        <Grid container item xs={12} justify="center">
          <Button
            variant="contained"
            onClick={() => {
              dispatch(loadFlights(formatFlightDate(flightDate)));
              modal.setToggle(false);
            }}
            style={{ backgroundColor: "#eb494e", fontWeight: "bold" }}
          >
            Close
          </Button>
        </Grid>
      </Paper>
    );
  }
}

export default withStyles(styles)(FlightModal);
